import CountUp from 'countup';

export default class NumberStats {
  constructor() {
    this.$elements = document.querySelectorAll('.c-number-stats');
    this.hasRan = false;
    this.$elements.forEach(element => this.setup(element));
  }

  /**
   * @function setup
   * @param {HTMLSectionElement} component
   * Creates the animations for this component
   */
  setup(component) {
    component.addEventListener('seatfrog.onBladeEnter', this.constructor.onEnter.bind(this, component));
  }

  /**
   * @function onEnter
   * @param {HTMLSectionElement} component
   * @param {Event} e
   * Fired when the component enters the viewport
   */
  static onEnter(component) {
    const $numbers = component.querySelectorAll('.c-number-stats__number');

    $numbers.forEach((number) => {
      const from = parseInt(number.dataset.from);
      const to = parseInt(number.dataset.to);
      const el = number.querySelector('.c-number-stats__animated');
      const animation = new CountUp(el, from, to);

      if (!animation.error) {
        animation.start();
        component.dataset.hasRan = true;
      }
    });
  }
}